export class NotificationClientRegistration {
    constructor() {
        /**
         * Device token generated by Firebase API
         */
        this.DeviceToken = "";
        /**
         * Unique client name (id of browser, mobile app or other client)
         */
        this.ClientName = "";
        this.LavvaUserName = "";
        this.EnableNotifications = true;
    }
}
export var NotificationClientType;
(function (NotificationClientType) {
    NotificationClientType[NotificationClientType["Unknown"] = -1] = "Unknown";
    NotificationClientType[NotificationClientType["Web"] = 0] = "Web";
    NotificationClientType[NotificationClientType["Android"] = 1] = "Android";
    NotificationClientType[NotificationClientType["iOS"] = 2] = "iOS";
})(NotificationClientType || (NotificationClientType = {}));
export class DeviceTokenMetadata {
    constructor() {
        this.ClientName = "";
        this.LavvaUserName = "";
        this.ClientType = NotificationClientType.Unknown;
        this.TokenGuid = "";
        this.Token = "";
        this.RegistrationDate = new Date();
    }
}
export var NotificationsServiceErrorCode;
(function (NotificationsServiceErrorCode) {
    NotificationsServiceErrorCode["FeatureUnsupported"] = "FeatureUnsupported";
    NotificationsServiceErrorCode["UnknownError"] = "UnknownError";
    NotificationsServiceErrorCode["NoData"] = "NoData";
    NotificationsServiceErrorCode["IncorrectGuid"] = "IncorrectGuid";
    NotificationsServiceErrorCode["IdentityIsEmpty"] = "IdentityIsEmpty";
    NotificationsServiceErrorCode["DeviceTokenIsEmpty"] = "DeviceTokenIsEmpty";
    NotificationsServiceErrorCode["ClientNameIsEmpty"] = "ClientNameIsEmpty";
    NotificationsServiceErrorCode["LavvaUserNameIsEmpty"] = "LavvaUserNameIsEmpty";
    NotificationsServiceErrorCode["TokenNotFound"] = "TokenNotFound";
    NotificationsServiceErrorCode["TokensNotFoundForLavvaUser"] = "TokensNotFoundForLavvaUser";
})(NotificationsServiceErrorCode || (NotificationsServiceErrorCode = {}));
//# sourceMappingURL=IControllerNotificationsService.js.map